<template>
    <div class="selectorignored workerframe" v-bind:class="{'notedited': !editedWorker['edit']}">
        <template>
            <div class="container" style="width: 3%; margin: auto;" v-if="!loaded">
                <div class="preloader-wrapper active">
                    <div class="spinner-layer spinner-red-only">
                        <div class="circle-clipper left">
                            <div class="circle"></div>
                        </div>
                        <div class="gap-patch">
                            <div class="circle"></div>
                        </div>
                        <div class="circle-clipper right">
                            <div class="circle"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" style="width: 100%;" v-if="loaded">
                <div id="mailinfo" class="modal" style="width: 500px;">
                    <div class="modal-content">
                        <h6>{{question}}</h6>
                    </div>
                    <div class="modal-footer">
                        <a class="modal-close waves-effect waves-light btn-small green">{{$t('menu.buttons.understand')}}</a>
                    </div>
                </div>
                <div class="col s3">
                    <template v-if="editedWorker.photo == undefined">
                        <img src="/nofoto.png" width="200" />
                    </template>
                    <template v-else>
                        <v-lazy-image v-bind:src="editedWorker.photo" src-placeholder="/nofoto.png" width="200" />
                    </template>
                    
                    <input type="file" id="input" @change="setImageFile(editedWorker, $event.target.name, $event.target.files)" v-if="editedWorker.edit">
                </div>
                <div class="col s3">
                    <div class="row">
                        <div class="col s4 right-align" style="line-height: 2;">{{$t('worker.name')}}</div>
                        <div class="input-field col s8"><input type="text" name="name" v-model="editedWorker.name" placeholder="Nazwa" :disabled="editedWorker.edit == false" /></div>
                        <div class="col s4 right-align" style="line-height: 2;">{{$t('worker.position')}}</div>
                        <div class="input-field col s8"><input type="text" placeholder="Stanowisko" v-model="editedWorker.position" :disabled="editedWorker.edit == false" /></div>
                        <div class="col s4 right-align" style="line-height: 2;">{{$t('worker.email')}}</div>
                        <div class="input-field col s8">
                            <input type="email" name="email" v-model="editedWorker.invitation_email" placeholder="Adres email" :disabled="editedWorker.edit == false" v-bind:class="{'error': mailerror != ''}" />
                            <p style="color: #c22026; font-size: 0.7em; margin-top: 0px; text-align: left;">{{mailerror}}</p>
                        </div>
                    </div>
                </div>
                <div class="col s3">
                    <div class="row">
                        <div class="col s3 right-align" style="line-height: 2;">{{$t('worker.surname')}}</div>
                        <div class="input-field col s9"><input type="text" name="surname" v-model="editedWorker.surname" :placeholder="$t('worker.surname')" :disabled="editedWorker.edit == false" /></div>
                        <div class="col s3 right-align" style="line-height: 2;">{{$t('worker.status')}}</div>
                        <div class="input-field col s5" style="padding-right: 4px;">
                            <select v-model="editedWorker.active" :disabled="editedWorker.edit == false">
                                <option value="true">{{$t('worker.active')}}</option>
                                <option value="false">{{$t('worker.inactive')}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col s3 right-align" style="line-height: 2;">{{$t('worker.initials')}}</div>
                        <div class="input-field col s5"><input v-model="editedWorker.symbol" :disabled="editedWorker.edit == false" /></div>
                        <div class="col s12">
                        <label>
                            <input type="checkbox" v-if="editedWorker.isadmin" checked="true" :disabled="true" />
                            <input type="checkbox" v-else  name="extended_priviliges" v-model="editedWorker.extended_priviliges" :disabled="editedWorker.edit == false" />
                            <span style="color: black;">{{$t('worker.extended_priviliges')}}</span>
                        </label>
                    </div>
                    </div>
                </div>
                <div class="col s3">
                    {{$t('worker.signature')}}<br />
                    <img class="signatureimage" height="150" width="300" v-if="editedWorker.signature_image == null"/>
                    <img class="signatureimage" height="150" width="300" v-if="editedWorker.signature_image != null" :src="`${editedWorker.signature_image}`" />
                    <input type="file" id="input" @change="setSignature(editedWorker, $event.target.name, $event.target.files)" v-if="editedWorker.edit">
                </div>
            </div>
            <div class="row" style="margin-top: 16px;" v-if="loaded && editedWorker.editable">
                <div class="col offset-l6 s4 l4" style="text-align: right;">
                    <a class="waves-effect waves-light btn-large red" v-if="worker.removable" :disabled="!editedWorker.assets_removable" v-on:click="deleteWorker(editedWorker)">{{$t('menu.buttons.delete')}}</a>
                    <a class="waves-effect waves-light btn-large emptygreen" v-on:click="editWorker(editedWorker)" v-if="editedWorker.edit == false">{{$t('menu.buttons.edit')}}</a>
                    <a class="waves-effect waves-light btn-large emptygreen" v-on:click="unEditWorker(editedWorker)" v-if="editedWorker.edit"> {{$t('menu.buttons.cancel_changes')}}</a>
                </div>
                <div class="col l2 s4" style="text-align: right; "><a style="width: 100%;" class="waves-effect waves-light btn-large solidgreen" v-on:click="saveWorker(editedWorker)" v-if="editedWorker.edit">
                        <div v-if="saving" class="preloader-wrapper small active">
                            <div class="spinner-layer spinner-red-only">
                                <div class="circle-clipper left">
                                    <div class="circle"></div>
                                </div>
                                <div class="gap-patch">
                                    <div class="circle"></div>
                                </div>
                                <div class="circle-clipper right">
                                    <div class="circle"></div>
                                </div>
                            </div>
                        </div>
                        {{saving == false ? $t('menu.buttons.save_changes') : ""}}
                    </a></div>
            </div>
        </template>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    data: function() {
        return {
            order: 1,
            orderby: 'number',
            customers: [],
            saving: false,
            instances: null,
            question: "",
            mailerror: "",
            loaded: false,
            editedWorker: {}
        }
    },
    props: { worker: Object },
    async mounted() {
        var elems = this.$el.querySelectorAll('.modal');
        this.instances = M.Modal.init(elems, {});
        if (this.worker.id == null && this.worker.id == undefined){
            this.loaded = true;
            this.editedWorker = {edit: true, name: "", surname: "", invitation_email: "", editable: true, active: true}
        }else {
            var resp = await axios.get("/workers/" + this.worker.id + ".json")
            this.loaded = true;
            this.assignEditedWorker(resp.data);
        }
    },
    created() {
        if (_.isUndefined(this.worker.media)) {
            this.worker.media = []
            this.worker.media.push({ "image": "" });
            this.worker.signature_image = this.worker.signature
            this.worker.invitation_email = this.worker.email
        }
    },
    methods: {
        assignEditedWorker: function(response){
            var resp = _.cloneDeep(response);
             if(resp.signature != null){
                if(resp.signature.indexOf("data:image/png;base64,") == -1 ){
                    resp.signature_image = "data:image/png;base64,"+response.signature;
                }else{
                    resp.signature_image = response.signature;
                }
            }
            resp.edit = false;
            resp.invitation_email = this.worker.email;
            this.editedWorker = resp;
        },
        collapse: function(customer) {
            customer.collapsed = !(customer.collapsed);
            this.$forceUpdate();
        },
        set_order: function(order) {
            if (this.orderby == order) {
                if (this.order == 1) {
                    this.order = 0
                } else if (this.order == 0) {
                    this.order = 1
                }

            } else {
                this.orderby = order;
            }
        },
        setSignature: async function(worker, name, file) {
            if(file.length > 0){
                if(file[0].type == "image/png"){
                    const toBase64 = file => new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = () => resolve(reader.result);
                        reader.onerror = error => reject(error);
                    });
                    const result = await toBase64(file[0]).catch(e => Error(e));
                    if (result instanceof Error) {
                        console.log('Error:', result.message);
                        return;
                    }
                    worker.signature = result
                    worker.signature_image = result
                    this.$forceUpdate();
                }else{
                    alert("Nieprawidłowy format pliku - wymagany format PNG");
                }
            }
        },
        setImageFile: async function(doc, name, file) {
            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
            const result = await toBase64(file[0]).catch(e => Error(e));
            if (result instanceof Error) {
                console.log('Error: ', result.message);
                return;
            }
            doc.photo = result;
            doc.media[0].image = file[0];
            this.$forceUpdate();
        },
        deleteWorker: async function(worker){
            if(worker.removable){
                var response = await axios.delete('/workers/' + worker.id + '.json')
                this.unEditWorker(worker);
                this.$emit("workerRemove", worker)
            }
        },
        editWorker: function(worker) {
            worker.edit = true;
            this.$forceUpdate();
        },
        emailIsValid: function(email) {
            return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
        },
        unEditWorker: function(worker) {
            if (worker.id != undefined) {
                worker.edit = false;
                this.$forceUpdate();
                this.editedWorker = _.cloneDeep(worker);
            } else {
                this.$emit('cancelAdding');
            }
        },
        saveWorker: async function(worker) {
            this.saving = true;
            const formData = new FormData();
            worker.extended_priviliges ||= false;
            for (var key of Object.keys(worker)) {
                if(_.isUndefined(worker[key]) == false){
                    if(key == "signature" || key == "signature_image"){
                        if(worker[key] && worker[key].indexOf("data:image/png;base64,") == 0 ){
                            formData.append('worker[' + key + ']', worker[key].split(",")[1]);
                        }
                    }else if (_.isNull(worker[key]) == false) {
                        formData.append('worker[' + key + ']', worker[key]);
                    }
                }
            }
            var i = 0;
            if(_.isUndefined(worker.media) == false){
                for (var reco of worker.media) {
                    if (worker.media[0].image != "") {
                        for (var key of Object.keys(reco)) {
                            formData.append('worker[media_attributes][' + i + '][' + key + ']', reco[key]);
                        }
                    }
                    if (reco.destroy) {
                        formData.append('worker[media_attributes][' + i + '][_destroy]', true);
                    }
                    i += 1;
                }
            }
            var valid = true;
            this.mailerror = "";
            if (worker.invitation_email == "" || _.isUndefined(worker.invitation_email)) {
                this.mailerror = "Podaj adres email";
                this.valid = false;
                this.$forceUpdate();
                this.saving = false;
                return;
            }
            if (this.emailIsValid(worker.invitation_email) == false) {
                this.mailerror = "Nieprawidłowy format adresu email";
                this.valid = false;
                this.$forceUpdate();
                this.saving = false;
                return;
            }

            var that = this;
            if (_.isUndefined(worker.id)) {
                if (valid) {
                    try {
                        var response = await axios.post('/workers.json', formData)
                        // this.worker.id = response.data.id;
                        this.unEditWorker(worker);
                        this.assignEditedWorker(response.data);
                        this.$emit("addWorker", response.data)
                    } catch (e) {
                        console.log(e);
                        this.question = _.flatten(_.values(e.response.data)).join(", ");
                        this.instances[0].open();
                    }
                }
                this.saving = false;
            } else {
                try {
                    var response = await axios.put('/workers/' + worker.id + '.json', formData)
                    this.unEditWorker(worker);
                    this.assignEditedWorker(response.data);
                    this.$emit("updateWorker", response.data)
                } catch (e) {
                    console.log(e);
                    this.question = _.flatten(_.values(e.response.data)).join(", ");
                }
                this.saving = false;
            }
        },
       
    },
    computed: {
        signature() {
            return this.worker.signature;
        }
    }
}
</script>
<style scoped>
.login_button {
    color: red;
}

p {
    font-size: 2em;
    text-align: center;
}

nav {
    background-color: #626262;
    height: 100px;
}

nav a {
    margin: 15px;
}

select {
    display: block;
}

.settingsform .btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.solidgreen {
    background-color: #00CC66 !important;
}

select {
    display: block;
    background-color: white !important;
    border-radius: 4px !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
    padding-left: 5px !important;
    height: 35px !important;
}

.input-field {
    margin-top: 0;
    margin-bottom: 0;
}

.signatureimage {
    display: block;
    background-color: white !important;
    border-radius: 4px !important;
    border-width: 1px !important;
    border-style: solid !important;
    border-color: rgb(140, 140, 140) !important;
    padding-left: 5px !important;
}
.btn-large[disabled]{
    opacity: 0.4;
    color: black;
}

input.error {
    border-color: #c22026 !important;
}

.workerframe {
    padding: 1em 0 1em 1em;
}
</style>